export default {"src":"/_next/static/media/star.d99940c2.svg","height":88,"width":82,"blurWidth":0,"blurHeight":0};